import { NotificationProvider } from "../../../contexts/notification-context";
import { MobileOpenChatList } from "../../chat/chat";
import { Header } from "../../common/header";

export const Conversations = () => {
    return (
        <div className="conversations-page">
            <NotificationProvider>
                <div className="conversations-page__header">
                    <Header title={``} />
                </div>
                <div className="conversations-page__content">
                    <MobileOpenChatList />
                </div>
            </NotificationProvider>
        </div>
    );
};
